import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'
import { toast } from 'react-toastify'

export async function getExcelLatestUpdates(){
    try {
        const response =  await axios(`${DATAMASTER_ENDPOINT}/getLatestUpdatesReport`,
            {
                method: "GET",
                timeout: 150000
            }
        )
        const res = response.data

        // TODO: maybe generate a helper function
        const link = document.createElement('a');
        link.href = res.downloadUrl;
        document.body.appendChild(link);
        toast.success('Archivo descargado correctamente')
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error(error)
        if (error?.response?.status === 404) {
            toast.warn(error?.response?.data?.message || 'No se encontraron datos')
        } else {
            toast.error('Error al descargar archivo')
        }
    }
}
